<template>
 <div id="notifications">
    <b-modal
      hide-footer
      id="modal-notifications"
      :title="modalTitle"
      body-class="p-0">

      <div id="list-notifications">
        <span v-for="notification in notifications" :key="notification.id">
          <NotificationItem :notification="notification" />
          <hr />
        </span>

        <!-- Show the "More" button only if there are more notifications to load -->

        <div v-if="thereIsMore" class="text-center">
          <button @click='addMoreNotifications()' class="bg-orange btn btn-sm my-3">More</button>
        </div>

      <!-- Show this informative text in other case -->
        <div class="text-center" v-else>
          <small>No more notifications.</small>
        </div>
      </div>
    </b-modal>
    <span class="p1 fa-stack fa-1x has-badge" :data-count="unhandledNotificationCount">
        <i class="p2 fa fa-circle fa-stack-2x"></i> 
        <i class="p3 fas fa-bell fa-stack-1x fa-inverse"></i>
        <b-dropdown size="lg"  variant="link" toggle-class="text-decoration-none" no-caret right shadow-none>
        <b-dropdown-item @click="showUnhandled()" shadow-none
          >Unhandled notifications</b-dropdown-item >
        <b-dropdown-item @click="showHandled()" shadow-none
          >All notifications</b-dropdown-item>
      </b-dropdown>
    </span>

  </div>
</template>
<script>

import NotificationItem from "./NotificationItem";
import config from '../../../config';
import { eventBus } from "../../main";

export default {
  name: "NotificationBell",
  components: { NotificationItem },
  data() {
    return {
      modalTitle: "Unhandled Notifications",
      notifications: [],
      unhandledNotificationCount: null, // Total number of notifications (all)
      allNotificationsStart: 0, // Start field in API
      pageSize: 10, // Count field in API, always 10 as we always want to render notifications by 10
      thereIsMore: false, // if there are more notifications
      notificationsOpen: false, // Open/Close handler
    };
  },
  created() {

    eventBus.$on("NotificationClick", () => {
      this.loadBellCount();
    });
  },
  methods: {

    showUnhandled() {
      this.loadUnhandledNotifications()
      .then( () => {
        this.modalTitle = "Unhandled Notifications";

       // show the modal
        this.$bvModal.show('modal-notifications');
      });

    },

    showHandled() {
      this.allNotificationsStart = 0;
      this.modalTitle = "All Notifications";
      this.loadAllNotifications()
      .then( () => {
        // show the modal
        this.$bvModal.show('modal-notifications')
      });
    },

    handleNotifications() {
      this.notificationsOpen = !this.notifications;
    },

    addMoreNotifications() {
      this.allNotificationsStart += this.pageSize;
      this.loadAllNotifications();
    },

    loadUnhandledNotifications() {
      return this.$store
        .dispatch("loadNotifications", {
          notificationsStart: '',
          notificationsCount: '',
        })
        .then((response) => {
          this.thereIsMore = false
          this.notifications.splice(0, this.notifications.length, ...response.notifications);
        })
        .catch((error) => console.info(error));
    },

    loadBellCount() {
      this.$store
        .dispatch("loadNotifications", {
          notificationsStart: '',
          notificationsCount: '',
        })
        .then((response) => {
          if( response.notifications.length == 0 ) {
            this.unhandledNotificationCount = null;
          } else {
            this.unhandledNotificationCount = response.notifications.length;
          }
        })
        .catch((error) => console.info(error));
    },

    loadAllNotifications() {
      return this.$store
        .dispatch("loadNotifications", {
          notificationsStart: this.allNotificationsStart,
          notificationsCount: this.pageSize+1,
        })
        .then((response) => {
          console.log( response );
          this.thereIsMore = ( response.notifications.length > this.pageSize );
          if( this.thereIsMore ) {
            response.notifications.length = this.pageSize;
          }
          this.notifications.splice( 0, this.pageSize, ...response.notifications);
        })
        .catch((error) => console.info(error));
    },

    notificationFeed() {
        console.log( "Feed request" )
        this.loadBellCount();
        this.feedFunction = setTimeout(() => {
          this.notificationFeed()
        }, config.api.notificationReloadTime );
    }
  },
  mounted: function () {
     this.notificationFeed();
  },
  destroyed () {
    if( this.feedFunction ) {
      clearTimeout( this.feedFunction )
    }
  }

};
</script>

<style scoped>
hr {
  margin: 0 !important;
}
#list-notifications{
    max-height: 600px;
    margin-bottom: 10px; 
    overflow-y:scroll;
    -webkit-overflow-scrolling: touch;
}
.badge {
    font-size: 1em;
    display: block;
    position: absolute;
    top: -.75em;
    right: -.95em;
    width: 2em;
    height: 2em;
    line-height: 2em;
    border-radius: 50%;
    text-align: center;
    color: #7f7f7f;
    
}
.fa-stack[data-count]:after{
  position:absolute;
  right:0%;
  top:-20%;
  content: attr(data-count);
  font-size:70%;
  padding:.6em;
  border-radius:999px;
  line-height:.75em;
  color: white;
  background:rgba(255,0,0,.85);
  text-align:center;
  min-width:2em;
  font-weight:bold;
}
</style>



// WEBPACK FOOTER //
// src/components/notifications/NotificationBell.vue